import MoreHorizSvg from "../../assets/more_horiz.svg";
import AdminIconSvg from "../../assets/images/ActionCard/AdminIcon.svg";
import DashboardIconSvg from "../../assets/sidebar/dashboard_selected.svg";
import vmoBotOutlined from "../../assets/vmoBotOutlined.svg";
import keyContractClausesOutlined from "../../assets/keyContractClausesOutlined.svg";
import contractRedliningOutlined from "../../assets/contractRedliningOutlined.svg";
import vomRobot from "../../assets/vmoRobot.svg";
import clauseCheckSvgSelected from "../../assets/clause_check_selected.svg";
import clauseCheckSvgUnselected from "../../assets/clause_check_unselected.svg";
import contractRedliningSvgSelected from "../../assets/contract_redlining_selected.svg";
import contractRedliningSvgUnselected from "../../assets/contract_redlining_unselected.svg";
import talkToContractSvgSelected from "../../assets/talk_to_contract_selected.svg";
import talkToContractSvgUnselected from "../../assets/talk_to_contract_unselected.svg";
import RfxGeneratorSvg from "../../assets/images/rfx_generator_icon.svg";
import RfxEvaluationSvg from "../../assets/images/rfx_evaluation_icon.svg";
import RfxGeneratorSvgUnselected from "../../assets/images/rfx_generator_unselected.svg";
import RfxGeneratorSelectedSvg from "../../assets/images/rfx_generator_selected.svg";
import RfxEvaluationUnselectedSvg from "../../assets/images/rfx_evaluation_unselected.svg";
import RfxEvaluationMainSvg from "../../assets/images/rfx_evaluation_main_icon.svg";
import VMoBotSecondarySvg from "../../assets/vmoBotSecondary.svg";
import { HeaderActionsType, TemplateOptionType, vmoBotType } from "./types";
import { ROUTES } from "../../common/constants";
import { Point } from "./types";

export const headerActionsForContractReview: Array<HeaderActionsType> = [
  // { text: "Upload", img: UploadGreySvg, height: "14px" },
  // { text: "Copy", img: ContentCopySvg, height: "14px" },
  // { text: "Save", img: BookMarkSvg, height: "14px" },
  { text: "ThreeDots", img: MoreHorizSvg, height: "14px", renderOptions: true },
];

export const headerActionsForClauseCheck: Array<HeaderActionsType> = [
  // { text: "Upload", img: UploadGreySvg, height: "14px" },
  { text: "ThreeDots", img: MoreHorizSvg, height: "14px", renderOptions: true },
];

export const GREEN = "green";

export const CONTRACT_REVIEW = "Contract Review";
export const SummaryMetricsType = {
  INTEGER: "integer",
  PERCENT: "percent",
};

export const metDataMapper: any = {
  vertical: "Vertical",
  contract_id: "Contract ID",
  vendor_name: "Vendor Name",
  service_type: "Service Type",
  contract_type: "Contract Type",
  maximum_total_cost: "MTC",
};

export const hideMetaDataForContractReview = [
  "contractId",
  "contract_type",
  "service_type",
  "vendor_name",
  "maximum_billable_hours",
  "start_date",
  "end_date",
  "documentId",
  "simbaId",
];

export const hideMetaDataForClauseCheck = [
  "contractId",
  "contract_type",
  "vendor_name",
  "maximum_total_cost",
  "maximum_billable_hours",
  "start_date",
  "end_date",
  "documentId",
  "simbaId",
];

export const CONTRACTS_REVIEW_PENDING = "Contracts Pending Review";
export const CONTRACT_REVIEW_PENDING_HEADER_DESCP =
  "List of uploaded contracts awaiting AI review and redlining.";
export const CONTRACTS_COMPLETE_REVIEW_HEADER_DESCP =
  "List of contracts with AI redlining review completed.";
export const CONTRACTS_COMPLETE_REVIEW = "Contracts Complete Review";
export const CONTRACTS_PENDING_CLAUSE_CHECK = "Contracts Pending Compliance";
export const CONTRACTS_PENDING_CLAUSE_CHECK_HEADER_DESCP =
  "List of bulk-uploaded contracts awaiting clause check.";
export const CONTRACT_COMPLIANCE = "Compliance Clause Checked";
export const CONTRACT_COMPLIANCE_HEADER_DESCP =
  "Total number of contracts reviewed for clause presence and compliance.";
export const recommendationTooltipText =
  "Displays the number of AI generated suggestions per clause.";
export const standardClausesTooltipText =
  "List of contracts where standard clauses are present.";
export const viewAllBtnTooltipTextForContractRedlining =
  "Displays all uploaded contracts including pending and completed AI reviews.";
export const viewAllBtnTooltipTextForClauseCheck =
  "Displays all uploaded contracts including pending and completed AI clause check.";
export const summaryBtnTooltipText =
  "Displays a summary of clause presence for the latest set of contracts uploaded.";

export const defaultSuggestions = [
  { text: "What are the Start and End dates for all the contracts?" },
  { text: "What is the scope of the Supplier's services?" },
  { text: "What is the maximum total cost for each contract?" },
  { text: "What is the minimum Service Level Credit Allocation?" },
];

export const ttcModelTooltips = [
  {
    label: "Gemini 1.5 Pro",
    value:
      "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points.",
  },
  {
    label: "Gemini 1.5 Flash",
    value:
      "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary.",
  },
];
export const ttcGeminiModel: any = {
  GEM_1_5_PRO_001: {
    displayName: "Gemini 1.5 Pro - 001",
    name: "gemini-2.5-pro",
    toolTipInfo:
      "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points.",
  },
  GEM_1_5_PRO_002: {
    displayName: "Gemini 1.5 Pro - 002 (latest)",
    name: "gemini-1.5-pro-002",
    toolTipInfo:
      "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points.",
  },
  GEM_1_5_FLASH_001: {
    displayName: "Gemini 1.5 Flash - 001",
    name: "gemini-2.0-flash",
    toolTipInfo:
      "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary.",
  },
  GEM_1_5_FLASH_002: {
    displayName: "Gemini 1.5 Flash - 002 (latest)",
    name: "gemini-1.5-flash-002",
    toolTipInfo:
      "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary.",
  },
};
export const defaultStateOfVmoBot: vmoBotType = {
  open: false,
  chat: [],
  suggestions: defaultSuggestions,
  fileUpload: {
    processingStage: "SelectFiles",
    uploadedFiles: [],
    uploadingState: true,
    processedFiles: [],
  },
  isMessageLoading: false,
  selectedModel: ttcGeminiModel.GEM_1_5_PRO_001,
  openModalState: true,
};

export const clauseCheckDocStatus = {
  CLAUSE_CHECK_IN_PROGRESS: "clause_check_in_progress",
  META_DATA_EXTRACTED: "meta_extraction_completed",
  CLAUSE_CHECK_READY: "clause_check_ready_for_review",
  META_DATA_TO_BE_EXTRACTED: "meta_data_to_be_extracted",
  CLAUSE_CHECK_COMPLETED: "clause_check_completed",
  UPLOAD_IN_PROGRESS: "upload_in_progress",
  UPLOAD_COMPLETED: "upload_completed",
  META_EXTRACTION_IN_PROGRESS: "meta_extraction_in_progress",
  FAILED_WHILE_REVIEWING: "failed_while_reviewing",
};

export const workBenchStatus = {
  DRAFT: "draft",
  ASSIGNING_CATEGORY_MANAGER: "assigning_category_manager",
  SUBMITTED_FOR_APPROVAL: "submitted_for_approval",
  META_EXTRACTION_IN_PROGRESS: "meta_extraction_in_progress",
};

export const bulkClauseApiPropForLatestUpload = {
  clause_status: [
    clauseCheckDocStatus.UPLOAD_IN_PROGRESS,
    clauseCheckDocStatus.UPLOAD_COMPLETED,
    clauseCheckDocStatus.META_EXTRACTION_IN_PROGRESS,
    clauseCheckDocStatus.META_DATA_EXTRACTED,
    clauseCheckDocStatus.CLAUSE_CHECK_IN_PROGRESS,
    clauseCheckDocStatus.CLAUSE_CHECK_READY,
  ],
};

export const bulkClauseApiProp = {
  clause_status: [
    clauseCheckDocStatus.UPLOAD_IN_PROGRESS,
    clauseCheckDocStatus.UPLOAD_COMPLETED,
    clauseCheckDocStatus.META_EXTRACTION_IN_PROGRESS,
    clauseCheckDocStatus.META_DATA_EXTRACTED,
    clauseCheckDocStatus.CLAUSE_CHECK_IN_PROGRESS,
    clauseCheckDocStatus.CLAUSE_CHECK_READY,
    clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED,
  ],
};

export const uploadStatus = {
  LATEST: "latest",
};

export const actionTypes: any = {
  DASHBOARD: "dashboard",
  ADMIN: "admin",
};

export const actionCards: any = {
  [actionTypes.DASHBOARD]: {
    backgroundImg:
      "https://s3-alpha-sig.figma.com/img/397b/2831/1d31cdd7b433bc882bccbfbee579f9c7?Expires=1728259200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=LttFIYksVFNbq~lYbqUyWRdiW7PH0lgzMvirhy5BebAGyy1rqfszQHN29qhIvhUAte7DyVhJ-LTBSQkP8inprV1CX6c1f76A69wtalzDqFdQCcmlobq2HKNUSxq-yLDvQhvOLLSs6N989a6eSrkss3PzLO-pg72IHa5AAvwrpeHVozenMuXm68EIxaOeV2MOyBGtasuuppxHyHu-moU~uiv9zOPnJK3whKyMFcRHSbcVOI9xCluWjbMkzRh6AyTwTj~Y1GBtl3EPjus9D43WuT5jkHIBbiC50D92QZnHzFNT2PD5mCHegZkfOlf5~D5hgQnV33ttlou7264LSdgPdw__",
    title: "Dashboard",
    subTitle: "Contract management",
    iconImg: DashboardIconSvg,
    imgStyle: {
      height: "28px",
      width: "28px",
    },
    redirectUrl: ROUTES.dashboard,
  },
  [actionTypes.ADMIN]: {
    backgroundImg:
      "https://s3-alpha-sig.figma.com/img/0192/7d4e/7725a7d6874097e28cdecb788ca581fb?Expires=1728259200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=RRjedEcR1LSgBMwrrad1bkettXNeBPeuOZeg6O6LJ9Z3NOVxI6vkl8Nl1teNhlFs2Q5AfbTkQuA~rEqLXIjG08ScxuC09ACIePBWactk-DR9hI78lrDxmo5GavNjJXWz98ACT9I1~KZFlSdHd99PXXQohP0iG5oqbS1LxDYp-zUkq9Rw4npLXMmQ92QryqEgVbRPiytZqdu6ptEk4toQ2HllbveQLCSP9YiHzlQpIQgtVL~UeRFt~v1JokjvVhNrx3QcEKVsxmOHh11MLhSJ~yMODRc5kMgCRgewxABSknNWgcQ5QxBsxIUuvtcuZAcxO35TE4vwUQ8~vOMG6XQbEQ__",
    title: "Manage",
    subTitle: "Manage users and clauses",
    iconImg: AdminIconSvg,
    imgStyle: {
      height: "28px",
      width: "28px",
    },
    redirectUrl: ROUTES.adminDashboard,
  },
};

export const VMO_BOT_MIN_MSG_LENGTH = 5;

export const MIN_MSG_ERROR = `hmmm, your input seems a bit too short, can you provide more than ${VMO_BOT_MIN_MSG_LENGTH} characters?`;
export const VMO_BOT_FILE_UPLOAD_LIMIT = 5;

export const LANDING_PAGE_TO_DASHBOARD_URLS = {
  contract_drafting: "contract_drafting",
  contract_redlining: "contract_review",
  clause_check: "clause_check",
  ttc: "ttc",
  rfx_generator: "rfx_generator",
  requirements_generator: "requirements_generator",
  rfx_evaluation: "rfx_evaluation",
  // breathing_dashboard: "breathing_dashboard",
};

export const DASHBOARD_FEATURES = {
  RFX_GENERATOR: "RFx Generator",
  REQUIREMENTS_GENERATOR: "Requirements Generator",
  RFX_EVALUATION: "RFx Evaluation",
  CONTRACT_DRAFTING: "Contract Drafting",
  CONTRACT_REDLINING: "Contract Review",
  CLAUSE_CHECK: "Key Contract Clauses",
  TALK_TO_CONTRACT: "Talk to Contract",
  // BREATHING_DASHBOARD: "Breathing Dashboard",
};

export const DASHBOARD_TABS = {
  [LANDING_PAGE_TO_DASHBOARD_URLS.contract_drafting]: {
    tab: DASHBOARD_FEATURES.CONTRACT_DRAFTING,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining]: {
    tab: DASHBOARD_FEATURES.CONTRACT_REDLINING,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.clause_check]: {
    tab: DASHBOARD_FEATURES.CLAUSE_CHECK,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.ttc]: {
    tab: DASHBOARD_FEATURES.TALK_TO_CONTRACT,
  },
  // [LANDING_PAGE_TO_DASHBOARD_URLS.breathing_dashboard]: {
  //   tab: DASHBOARD_FEATURES.BREATHING_DASHBOARD,
  // },
};

export const dashboardConfig = {
  [DASHBOARD_FEATURES.CONTRACT_REDLINING]: {
    mainIcon: contractRedliningOutlined,
    headerText: DASHBOARD_FEATURES.CONTRACT_REDLINING,
    description:
      "Review contracts through AI-powered redlining, markup and edit suggestions for faster contract negotiations and execution.",
    points: [
      {
        number: 23,
        description: "Uploaded Contracts",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
      {
        number: 7,
        description: "Pending Review",
        backgroundColor: "#E6A8000D",
        color: "#F57C00",
        border: "1px solid #E6A800",
        countKey: "pending",
      },
      {
        number: 12,
        description: "Completed Review",
        backgroundColor: "#0E9D580D",
        color: "#00796B",
        border: "1px solid #0E9D58",
        countKey: "completed",
      },
    ] as Point[],
    hoverText:
      "Review contracts through AI-powered redlining, markup and edit suggestions for faster negotiations and execution.",
    icon: {
      selected: contractRedliningSvgSelected,
      unselected: contractRedliningSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining,
  },
  [DASHBOARD_FEATURES.CONTRACT_DRAFTING]: {
    mainIcon: contractRedliningOutlined,
    headerText: DASHBOARD_FEATURES.CONTRACT_DRAFTING,
    description:
      "Review contracts through AI-powered redlining, markup and edit suggestions for faster contract negotiations and execution.",
    points: [
      {
        number: 10,
        description: "Contracts Drafted",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
    ] as Point[],
    hoverText:
      "Generate contract drafts quickly by just uploading the termsheet and populating the pre-defined templates for different contract types with help of GenAI.",
    icon: {
      selected: contractRedliningSvgSelected,
      unselected: contractRedliningSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.contract_drafting,
  },
  [DASHBOARD_FEATURES.CLAUSE_CHECK]: {
    mainIcon: keyContractClausesOutlined,
    headerText: DASHBOARD_FEATURES.CLAUSE_CHECK,
    description:
      "Bulk check to detect missing or non-standard compliance clauses.",
    points: [
      {
        number: 23,
        description: "Uploaded Contracts",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
      {
        number: 7,
        description: "Contracts Pending",
        backgroundColor: "#E6A8000D",
        color: "#F57C00",
        border: "1px solid #E6A800",
        countKey: "pending",
      },
      {
        number: 12,
        description: "Clause Checked",
        backgroundColor: "#0E9D580D",
        color: "#00796B",
        border: "1px solid #0E9D58",
        countKey: "completed",
      },
    ] as Point[],
    hoverText:
      "Bulk check to detect missing or non-standard compliance clauses.",
    icon: {
      selected: clauseCheckSvgSelected,
      unselected: clauseCheckSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.clause_check,
  },
  [DASHBOARD_FEATURES.TALK_TO_CONTRACT]: {
    mainIcon: vmoBotOutlined,
    headerText: DASHBOARD_FEATURES.TALK_TO_CONTRACT,
    description:
      "Extract key insights and answers from single or multiple uploaded contracts.",
    lightIcon: vomRobot,
    hoverTextOne:
      "Extract key insights and answers from single or multiple uploaded contracts.",
    hoverTextTwo:
      "Click to upload files you want to query from the AI Chat below.",
    icon: {
      selected: talkToContractSvgSelected,
      unselected: talkToContractSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.ttc,
    secondaryIcon: VMoBotSecondarySvg,
    hoverText:
      "Click to upload files you want to query from the AI-Chat below.",
  },
  // [DASHBOARD_FEATURES.BREATHING_DASHBOARD]: {
  //   mainIcon: breathingDashboardOutlined,
  //   headerText: DASHBOARD_FEATURES.BREATHING_DASHBOARD,
  //   description: "Coming Soon!",
  //   // points: [
  //   //   {
  //   //     number: 5,
  //   //     description: "Nearing Start Date",
  //   //     backgroundColor: "#0E9D580D",
  //   //     color: "#00796B",
  //   //     border: "1px solid #0E9D58",
  //   //   },
  //   //   {
  //   //     number: 2,
  //   //     description: "Nearing End Date",
  //   //     backgroundColor: "#E03C2F0D",
  //   //     color: "#D32F2F",
  //   //     border: "1px solid #E03C2F",
  //   //   },
  //   // ] as Point[],
  //   hoverText:
  //     "Stay on top of all your contracts with a real-time and up-to-date insights at a glance.",
  //   icon: {
  //     selected: breathingDashboardSvgSelected,
  //     unselected: breathingDashboardSvgUnselected,
  //   },
  //   featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.breathing_dashboard,
  // },
  [DASHBOARD_FEATURES.RFX_GENERATOR]: {
    mainIcon: RfxGeneratorSvg,
    headerText: DASHBOARD_FEATURES.RFX_GENERATOR,
    description:
      "Review contracts through AI-powered redlining, markup and edit suggestions for faster contract negotiations and execution.",
    points: [
      {
        number: 23,
        description: "RFX Generated",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
    ] as Point[],
    hoverText:
      "Quickly generate RFx documents by uploading the intake form and using GenAI to populate templates.",
    icon: {
      selected: RfxGeneratorSelectedSvg,
      unselected: RfxGeneratorSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.rfx_generator,
  },
  [DASHBOARD_FEATURES.REQUIREMENTS_GENERATOR]: {
    mainIcon: RfxGeneratorSvg,
    headerText: DASHBOARD_FEATURES.REQUIREMENTS_GENERATOR,
    description:
      "Quickly generate requirements documents by uploading the intake form and using GenAI to populate templates.",
    points: [
      {
        number: 23,
        description: "Requirements Generated",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
    ] as Point[],
    hoverText:
      "Quickly generate requirements documents by uploading the intake form and using GenAI to populate templates.",
    icon: {
      selected: RfxGeneratorSelectedSvg,
      unselected: RfxGeneratorSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.requirements_generator,
  },
  [DASHBOARD_FEATURES.RFX_EVALUATION]: {
    mainIcon: RfxEvaluationMainSvg,
    headerText: DASHBOARD_FEATURES.RFX_EVALUATION,
    description:
      "Review contracts through AI-powered redlining, markup and edit suggestions for faster contract negotiations and execution.",
    points: [
      {
        number: 10,
        description: "RFx Documents Evaluated",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
    ] as Point[],
    hoverText:
      "Upload RFP submissions to view agency scores and receive recommendation.",
    icon: {
      selected: RfxEvaluationSvg,
      unselected: RfxEvaluationUnselectedSvg,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.rfx_evaluation,
  },
};

export const MANAGE_CONTRACTS_FEATURES = {
  PENDING_REVIEW: "Pending Review",
  COMPLETED_REVIEW: "Completed Review",
};

export const manageContractsConfig = {
  [MANAGE_CONTRACTS_FEATURES.PENDING_REVIEW]: {
    mainIcon: contractRedliningOutlined,
    headerText: MANAGE_CONTRACTS_FEATURES.PENDING_REVIEW,
  },
  [MANAGE_CONTRACTS_FEATURES.COMPLETED_REVIEW]: {
    mainIcon: contractRedliningOutlined,
    headerText: MANAGE_CONTRACTS_FEATURES.COMPLETED_REVIEW,
  },
};

export const actionType = {
  UPLOAD: "upload",
  HOME_STORAGE: "homeStorage",
};

export const CLAUSE_CHECK = DASHBOARD_FEATURES.CLAUSE_CHECK;

export const key_contract_clauses_columns = [
  { field: "vendor_name", headerName: "Vendor" },
  { field: "display_name", headerName: "Contract Name" },
  { field: "vertical", headerName: "Vertical" },
  { field: "maximum_total_cost", headerName: "MTC" },
  { field: "service_type", headerName: "Service Type" },
  { field: "status", headerName: "Status" },
];

export const redliningColumns = [
  { field: "vendor_name", headerName: "Vendor" },
  { field: "display_name", headerName: "Contract Name", clickable: true },
  { field: "vertical", headerName: "Vertical" },
  { field: "maximum_total_cost", headerName: "MTC" },
];

export const recommendationsColors = [
  "#3B00ED",
  "#4285F4",
  "#43A047",
  "#C0CA33",
  "#FF9800",
  "#FFC107",
];

export const templateOptions: TemplateOptionType[] = [
  { value: "sow", label: "SOW" },
  { value: "sowAmendment", label: "SOW Amendment" },
];

export const tabsForRfxEvaluation = [
  {
    text: "Experience & General Capabilities",
    subText: "Agency Capability Score",
    disabled: false,
  },
  {
    text: "Case Studies",
    subText: "Work Examples evaluation",
    disabled: false,
  },
  {
    text: "Partnership Potential",
    subText: "Ideal Partnership Evaluation",
    disabled: false,
  },
  {
    text: "Presentation",
    subText: "Pitch Presentation Evaluation",
    disabled: false,
  },
];

export const TAB_FROM_INDEX_RFX_EVALUATION = [
  "EXPERIENCE & GENERAL CAPABILITIES",
  "CASE STUDIES",
  "PARTNERSHIP POTENTIAL",
  "PRESENTATION",
];

export const EMPTY_RFX_GENERATOR_DATA = {
  intakeFormValidated: false,
  file_name: "",
  fileUpload: {
    isUploading: false,
    error: {},
    uploaded: false,
  },
  rfxGeneratorSelectedTemplate: { id: "", intake_form_gcs_loc: "" },
  docId: "",
};

export const EMPTY_CONTRACT_DRAFTING_DATA = {
  intakeFormValidated: false,
  file_name: "",
  fileUpload: {
    isUploading: false,
    error: {},
    uploaded: false,
  },
  selectedTemplate: { id: "" },
  docId: "",
};

export const DOCUMENT_STORE = {
  NO_FILE: "No file have been shared with you at this time.",
};
